// extracted by mini-css-extract-plugin
module.exports = {"overlay":"VideoWithPreview-module-overlay--9NmHy","overlayLoader":"VideoWithPreview-module-overlayLoader--9SwaR"};